import React from 'react'
import { useTheme } from '@mui/material'
import { FlexDiv } from '../components'

interface MobileLayoutProps {
    children: React.ReactNode
}

export const MobileLayout: React.FC<MobileLayoutProps> = ({ children }) => {
    const theme = useTheme()

    return (
        <FlexDiv 
            direction="column" 
            style={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: theme.palette.background.default,
                margin: 0,
                padding: 0
            }}
        >
            {children}
        </FlexDiv>
    )
} 